import _ from 'underscore';
import getConfig from 'next/config';

import { getImageUrl, getEntityUrl } from '../cultureUtils';

const {
	publicRuntimeConfig: { baseUrl, basePath = '' }
} = getConfig();

const aboutHash = {
	institutes: 'Места',
	movies: 'Видео'
};

export const getTextBlocksFromJsonField = (jsonBlocks) =>
	_(jsonBlocks).reduce((memo, block) => {
		let text = '';

		if (_(['text', 'header', 'quote']).contains(block.type)) {
			text = block.text || '';
		} else if (block.type === 'html') {
			text = block.html;
		} else if (block.type === 'tabs') {
			text = getTextBlocksFromJsonField(block.items);
		} else if (block.type === 'tab') {
			text = getTextBlocksFromJsonField(block.content);
		}

		return [memo, text.replace(/<.*?>/g, '')].join(' ');
	}, '');

export const getBaseMicrodata = (entity, params) => {
	const { title, thumbnailFile, jsonText } = entity;
	const url = baseUrl + basePath + getEntityUrl(params.entityType, entity);
	const text = getTextBlocksFromJsonField(jsonText) || '';

	const baseMicrodata = {
		'@type': params.type,
		'@id': url,
		description: entity.shortText,
		url,
		'@context': 'http://schema.org',
		name: title,
		alternateName: title,
		text
	};

	if (thumbnailFile) {
		baseMicrodata.image = {
			'@type': 'ImageObject',
			url: getImageUrl(thumbnailFile),
			caption:
				thumbnailFile.meta &&
				(thumbnailFile.meta.title || thumbnailFile.meta.description),
			width: thumbnailFile.width,
			height: thumbnailFile.height
		};
	}

	const about = aboutHash[params.entityType] || aboutHash[entity.type];

	if (about) {
		baseMicrodata.about = [about];
	}

	return baseMicrodata;
};
